import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
// token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InBvaW50cyI6eyJwb2ludHNnYWduZXMiOltdLCJwb2ludHNjb25zb21tZXMiOltdfSwiZGF0ZSI6IjIwMjItMDktMTZUMTQ6MjA6MDMuMjM3WiIsIl9pZCI6IjYzMjQ4NjEzODcxNTg0MDUyYzk1MjE1YSIsIm5vbSI6Imxhc3QiLCJwcmVub20iOiJsYXN0IiwiZW1haWwiOiJhQGEuY29tIiwicGFzc3dvcmQiOiIkMmEkMTAkUjUzREJpZE14S0lvVlRCMWxKa3UxLmNyM1BSZnJmbjVOVm9zTVE4cHdPZFBjTGFvSzNKNzYiLCJ0ZWxlcGhvbmUiOiIwMTI0NTYzNCIsImFkcmVzc2UiOiIwMTI0NTYzNCIsIl9fdiI6MH0sImlhdCI6MTY2NDE4Nzg0MH0.51YHBOBahTfdCoQvFIMlBUTWAQxV5vPlVPP0CHuEBAg"
let config = {
    headers: {
        Authorization: "Bearer " + token
    }
};
const state = {
    isLoadProgrammes: false,
    programmeMenu: null,
    token
};

const getters = {
    isLoadProgrammes: state => state.isLoadProgrammes,
    programmeMenu: state => state.programmeMenu,
    
};

const mutations = {
    getProgrammeSuccess(state, payload) {
        state.isLoadProgrammes = true;
        state.programmeMenu = payload.programmeMenu;

    },

    getProgrammeError(state, error) {
        state.isLoadProgrammes = false;
    },
    loginSuccess(state, error) {  
        // state.token = ;
    },

};

const actions = {
   async getProgBymenu({commit}, payload ) {
        // token = localStorage.getItem("accessToken")
      return await axios
            .get(`${apiPath}/programme-menu/${payload.restaurant}/${payload.menu}`, config)
            .then(r => r.data)
            .then(res => {
                if (res.ok) {
                    commit("getProgrammeSuccess", {
                        programmeMenu: res.data,
                    });
                } else {
                    
                    commit("getProgrammeError");

                }
                return res
            });
    }


};

export default {
    state,
    getters,
    mutations,
    actions
};
